<script lang="ts">
	import type { i18n } from 'types/common'

	import { getContext } from 'svelte'

	interface Props {
		route?: string
	}

	let { route = '' }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<div
	class="container"
	style="margin-top: 20px;"
>
	<div class="well">
		<h1>
			{translate('notFound.sorryCouldntFindRoute', "Sorry, couldn't find route")}: {route}<small class="float-end">
				¯\_(ツ)_/¯</small
			>
		</h1>
	</div>
</div>
